import BpkBottomSheet from '@skyscanner/backpack-web/bpk-component-bottom-sheet';
import { PADDING_TYPE } from '@skyscanner/backpack-web/bpk-component-bottom-sheet/src/BpkBottomSheet';
import {
  BpkButtonV2,
  BUTTON_TYPES,
} from '@skyscanner/backpack-web/bpk-component-button';
import BpkText, {
  TEXT_STYLES,
} from '@skyscanner/backpack-web/bpk-component-text';
import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';

import StatementContent from '../StatementContent';

import type { I18nService } from '@shared/types/i18n';

import STYLES from '../RatingStatement.module.scss';

import { withI18n } from '@shared/ui/contexts/i18n';

const cls = cssModules(STYLES);

type Props = {
  isOpen: boolean;
  onClose: () => void;
  i18n: I18nService;
};

const StatementSheet = ({ i18n, isOpen, onClose }: Props) => (
  <div className={cls('RatingStatement__bottomSheet')}>
    <BpkBottomSheet
      id="rating-statement-sheet"
      isOpen={isOpen}
      onClose={onClose}
      ariaLabel={i18n.translate('rating_explaination_title')}
      closeLabel={i18n.translate('rating_explaination_close')}
      paddingStyles={{
        top: PADDING_TYPE.none,
        start: PADDING_TYPE.lg,
        end: PADDING_TYPE.lg,
        bottom: PADDING_TYPE.lg,
      }}
    >
      <div>
        <BpkText
          tagName="h5"
          textStyle={TEXT_STYLES.heading5}
          className={cls('RatingStatement__title')}
        >
          {i18n.translate('rating_explaination_title')}
        </BpkText>
        <StatementContent />

        <BpkButtonV2
          type={BUTTON_TYPES.primary}
          onClick={onClose}
          className={cls('RatingStatement__button')}
        >
          <BpkText textStyle={TEXT_STYLES.label1}>
            {i18n.translate('rating_explaination_close')}
          </BpkText>
        </BpkButtonV2>
      </div>
    </BpkBottomSheet>
  </div>
);

export default withI18n(StatementSheet);
